export const removeLeadingZero = (value: string) => {
  return value.replace(/^0+/, "");
};
